export const onboardingTestIDs = {
  pages: {
    onboardingHomePage: 'OnboardingHomePage',
    onboardingFreeTrialPage: 'OnboardingFreeTrialPage',
    deviceActivationPage: 'DeviceActivationPage',
    subscriberSignUpPage: 'SubscriberSignUpPage',
    subscriberSignInPage: 'SubscriberSignInPage',
    authVerificationPage: 'AuthVerificationPage',
    subscriptionSelectionPage: 'SubscriptionSelectionPage',
    subscriberWelcomeBackPage: 'SubscriberWelcomeBackPage',
    successPage: 'SuccessPage',
    errorPage: 'ErrorPage',
  },
  onboardingDebugMenu: {
    onboardingHomeButton: 'onboarding_debug_menu_onboarding_home_button',
    onboardingFreeTrialButton: 'onboarding_debug_menu_onboarding_free_trial_button',
    deviceActivationButton: 'onboarding_debug_menu_device_activation_button',
    authVerificationButton: 'onboarding_debug_menu_auth_verification_button',
    successButton: 'onboarding_debug_menu_success_button',
    errorButton: 'onboarding_debug_menu_error_button',
    subscriberSignInButton: 'onboarding_debug_menu_subscriber_sign_in_button',
    subscriberSignUpButton: 'onboarding_debug_menu_subscriber_sign_up_button',
    subscriberWelcomeBackButton: 'onboarding_debug_menu_subscriber_welcome_back_button',
    subscriptionConfirmationButton: 'onboarding_debug_menu_subscription_confirmation_button',
    subscriptionDetailsButton: 'onboarding_debug_menu_subscription_details_button',
    subscriptionSelectionButton: 'onboarding_debug_menu_subscription_selection_button',
  },
  onboardingHome: {
    pageLogo: 'onboarding_home_page_twc_logo',
    pageTitle: 'onboarding_home_page_title',
    pageSubtitle: 'onboarding_home_page_subtitle',
    pageBackgroundImage: 'onboarding_home_page_background_image',
    pageInfoSection: 'onboarding_home_page_title_section',
    subscribeText: 'onboarding_home_page_subscribe_text',
    subscribeButton: 'onboarding_home_page_subscribe_button',
    signInButton: 'onboarding_home_page_sign_in_button',
    signInText: 'onboarding_home_page_sign_in_text',
  },
  authVerification: {
    logoImage: 'auth_verification_page_logo_image',
    headingText: 'auth_verification_page_heading_text',
    headingTextUserEmail: 'auth_verification_page_heading_text_user_email',
    codeEntryInstructions: 'auth_verification_page_code_entry_instructions',
    codeEntryInput: 'auth_verification_page_code_entry',
    automaticallyUpdateText: 'auth_verification_page_automatically_update_text',
    sendNewCodeButton: 'auth_verification_page_send_new_code_button',
  },
  errorPage: {
    tryAgainButton: 'error_page_try_again_button',
    logoImage: 'error_page_logo_image',
    headingText: 'error_page_heading_text',
    errorMessage: 'error_page_error_message',
    assistanceText: 'error_page_assistance_text',
  },
  subscriberSignIn: {
    cableSignIn: {
      activateCode: 'subscriber_sign_in_page_cable_sign_in_activate_code',
      activateLink: 'subscriber_sign_in_page_cable_sign_in_activate_link',
      cableSection: 'subscriber_sign_in_page_cable_sign_in_cable_section',
      enterCodeText: 'subscriber_sign_in_page_cable_sign_in_enter_code_text',
      headingText: 'subscriber_sign_in_page_cable_sign_in_heading_text',
      newCodeButton: 'subscriber_sign_in_page_cable_sign_in_new_code_button',
      subheadingText: 'subscriber_sign_in_page_cable_sign_in_subheading_text',
      QRCodeImage: 'subscriber_sign_in_page_cable_sign_in_QR_code_image',
    },
    subscriberSignIn: {
      continueButton: 'subscriber_sign_in_page_subscriber_sign_in_continue_button',
      emailInput: 'subscriber_sign_in_page_subscriber_sign_in_email_input',
      headingText: 'subscriber_sign_in_page_subscriber_sign_in_heading_text',
      logoImage: 'subscriber_sign_in_page_subscriber_sign_in_logo_image',
      subscriberSection: 'subscriber_sign_in_page_subscriber_sign_in_subheading_text',
      subheadingText: 'subscriber_sign_in_page_subscriber_sign_in_subheading_text',
    },
  },
  subscriberSignUp: {
    logoImage: 'subscriber_sign_up_page_logo_image',
    headingText: 'subscriber_sign_up_page_heading_text',
    emailInput: 'subscriber_sign_up_page_email_input',
    continueButton: 'subscriber_sign_up_page_continue_button',
  },
  subscriberWelcomeBack: {
    pageTitle: 'subscriber_welcome_back_page_title',
    continueButton: 'subscriber_welcome_back_page_continue_button',
    logoImage: 'subscriber_welcome_back_page_logo_image',
    welcomeBackMessage: 'subscriber_welcome_back_message',
    finePrint1: 'subscriber_welcome_back_fine_print_1',
    finePrint2: 'subscriber_welcome_back_fine_print_2',
  },
  subscriptionConfirmation: {
    pageTitlePlaceholder: 'subscription_confirmation_page_title_placeholder',
    closeButtonPlaceholder: 'subscription_confirmation_page_close_button_placeholder',
    trialModeDebugSwitch: 'subscription_confirmation_page_trial_mode_debug_switch',
  },
  subscriptionDetails: {
    pageTitlePlaceholder: 'subscription_details_page_title_placeholder',
    viewButtonPlaceholder: 'subscription_details_page_view_button_placeholder',
  },
  subscriptionSelection: {
    headingText: 'subscription_selection_page_heading_text',
    monthlyTile: 'subscription_selection_page_monthly_tile',
    planDisclaimerText: 'subscription_selection_page_plan_disclaimer_text',
    subheadingText: 'subscription_selection_page_subheading_text',
    trialTermsText: 'subscription_selection_page_trial_terms_text',
    yearlyTile: 'subscription_selection_page_yearly_tile',
  },
  successPage: {
    successPageText: 'success_page_text',
  },
  onboardingFreeTrial: {
    step1Section: 'free_trial_page_step_1_section',
    logoImage: 'free_trial_page_logo_image',
    headingText: 'free_trial_page_heading_text',
    helperText: 'free_trial_page_helper_text',
    accountSetupLink: 'free_trial_page_account_setup_link',
    errorText: 'free_trial_page_error_text',
    doneButton: 'free_trial_page_done_button',
  },
  deviceActivation: {
    logoImage: 'device_activation_page_logo_image',
    headingText: 'device_activation_page_heading_text',
    activateLink: 'device_activation_page_activate_link',
    firstStepSection: 'device_activation_page_first_step_section',
    firstStep: 'device_activation_page_first_step',
    firstStepText: 'device_activation_page_first_step_text',
    secondStepSection: 'device_activation_page_second_step_section',
    secondStep: 'device_activation_page_second_step',
    secondStepText: 'device_activation_page_second_step_text',
    activationCode: 'device_activation_page_activation_code',
    expirationText: 'device_activation_page_expiration_text',
    thirdStepSection: 'device_activation_page_third_step_section',
    thirdStep: 'device_activation_page_third_step',
    thirdStepText: 'device_activation_page_third_step_text',
    focusTrap: 'device_activation_page_focus_default',
  },
};
